import { render, staticRenderFns } from "./deposit.vue?vue&type=template&id=343b3f88&scoped=true"
import script from "./deposit.vue?vue&type=script&lang=js"
export * from "./deposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343b3f88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('343b3f88')) {
      api.createRecord('343b3f88', component.options)
    } else {
      api.reload('343b3f88', component.options)
    }
    module.hot.accept("./deposit.vue?vue&type=template&id=343b3f88&scoped=true", function () {
      api.rerender('343b3f88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/deposit.vue"
export default component.exports